module.exports = "<station-page></station-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/station.html
// module id = 1396
// module chunks = 0